import { render, staticRenderFns } from "./index.vue?vue&type=template&id=02dd1066"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=02dd1066&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02dd1066')) {
      api.createRecord('02dd1066', component.options)
    } else {
      api.reload('02dd1066', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=02dd1066", function () {
      api.rerender('02dd1066', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/address/index.vue"
export default component.exports